import React from "react";
import { HamburgerButton } from "react-hamburger-button";
import styled from "styled-components";
// import Link from "gatsby-link";
import { Flex, Box } from "rebass";

const MENU_PADDING_LEFT = "1vw";
const HAMBURGER_WIDTH = 20;

const calcMenuLeft = (menuWidth, framePaddingX) => {
  return `
   calc(-${menuWidth} + ${framePaddingX} + ${MENU_PADDING_LEFT} + ${HAMBURGER_WIDTH}px)
`;
};

const HamburgerButtonWrapper = styled.div`
  &:hover {
    cursor: pointer;
    // & span {
    //   background: red !important;
    // }
  }
`;

const createMenuColor = colors => {
  const [r, g, b] = colors.blue.rgb;
  return `rgba(${r}, ${g}, ${b}, 0.9);`;
};

const Container = styled.div`
  a {
    text-decoration: none;
  }
  @keyframes open {
    from {
      left: ${({ width: menuWidth, theme }) =>
        calcMenuLeft(menuWidth, theme.space[theme.frame.px])};
      background: transparent;
    }
    to {
      left: 0;
      background: ${({ theme }) => createMenuColor(theme.colors)};
    }
  }

  @keyframes toBlack {
    from {
      color: white;
    }
    to {
      color: black;
    }
  }

  @keyframes toWhite {
    from {
      color: black;
    }
    to {
      color: white;
    }
  }

  @keyframes close {
    from {
      left: 0;
      background: ${({ theme }) => createMenuColor(theme.colors)};
    }
    to {
      left: ${({ width: menuWidth, theme }) =>
        calcMenuLeft(menuWidth, theme.space[theme.frame.px])};
      background: transparent;
    }
  }
  position: fixed;
  top: 0;
  left: ${({ width: menuWidth, theme }) =>
    calcMenuLeft(menuWidth, theme.space[theme.frame.px])};
  height: 100vh;
  padding-top: ${({ theme }) => theme.space[theme.frame.pt - 4]};
  z-index: 99;
  padding-left: 1vw;
  padding-right: 1vw;
  width: ${({ width }) => width};
  ${props => props.animation};
`;

const animationOpen = `
   animation-name: open;
   animation-duration: 0.3s;
   animation-fill-mode: forwards;
   * {
       animation-name: toWhite;
       animation-duration: 0.3s;
       animation-fill-mode: forwards;
   }
`;

const animationClose = `
   animation-name: close;
   animation-duration: 0.2s;
   animation-fill-mode: forwards;
   * {
       animation-name: toBlack;
       animation-duration: 0.3s;
       animation-fill-mode: forwards;
   }
`;

const NavItem = styled.div`
  text-transform: uppercase;
  padding-bottom: 0.2rem;
`;

const NavItemList = styled.div`
  z-index: 9;
  font-size: 2rem;
  height: 100%;
  padding-top: 20vh;
`;

export default props => {
  const { state: { hasBeenOpened, open }, navItems, width, toggleOpen } = props;
  const closeAnimation = hasBeenOpened ? animationClose : "";
  const menuAnimation = open ? animationOpen : closeAnimation;
  return (
    <Container width={width} animation={menuAnimation}>
      <Flex pb={100}>
        <Box w={1} h={1} pl="20px">
          <NavItemList>
            {navItems.map((item, i) => {
              const Component = item.component;
              return (
                <NavItem key={i}>
                  <Component {...item.props} />
                </NavItem>
              );
            })}
          </NavItemList>
        </Box>
        <Box>
          <HamburgerButtonWrapper>
            <HamburgerButton
              open={open}
              onClick={toggleOpen}
              width={HAMBURGER_WIDTH}
              height={HAMBURGER_WIDTH * 0.6}
              strokeWidth={2}
              color={open ? "white" : "black"}
              animationDuration={0.2}
            />
          </HamburgerButtonWrapper>
        </Box>
      </Flex>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/layouts/menu/mobile.js